export enum ChannelsAnalyticsDropdownType {
  CHANNELS,
  SUBCHANNELS
}
